import { Spinner as SpinnerBootstrap } from 'react-bootstrap';

export const Spinner = () => (
    <SpinnerBootstrap animation="border" variant="light">
        <span className="visually-hidden">Loading...</span>
    </SpinnerBootstrap>
);